import { DatePicker, Grid } from "@eworkit/iris";
import { format, isValid } from "date-fns";
import React from "react";
import { useTranslation } from "react-i18next";

interface ComponentProps extends Omit<React.HTMLAttributes<HTMLElement>, "value" | "onChange"> {
  value?: string;
  onChange?: (value: any, cb?: () => void) => void;
}
export const dateFormat = "yyyy-MM-dd";
export const isValidDate = (date?: Date | null): date is Date => isValid(date);
type DateType = Date | number;

export const parseDate = (date?: DateType | string | null) => {
  if (date instanceof Date) {
    return date;
  }
  return typeof date === "string" || typeof date === "number" ? new Date(date) : undefined;
};

const getValue = (from?: string, to?: string) => (from || to ? [from, to].join(",") : undefined);

const DateRangeComponent: React.FC<ComponentProps> = ({ value, onChange, ...props }) => {
  const { t } = useTranslation(["session", "common"]);

  const [from, to] = React.useMemo(() => {
    const [fromString, toString] = (value || ",").split(",");
    return [fromString, toString].map((item: string) => (isValidDate(parseDate(item)) ? item : undefined));
  }, [value]);

  const handleChange = (dates: string | undefined) => {
    onChange?.(dates);
  };

  const handleFromChange = (val: any) => handleChange(getValue(val ? format(val, dateFormat) : "", to));
  const handleToChange = (val: any) => handleChange(getValue(from, val ? format(val, dateFormat) : ""));

  return (
    <Grid columns={2} gap="xs" {...props} sx={{ minWidth: 270 }}>
      <DatePicker onChange={handleFromChange} value={parseDate(from)} clearable placeholder={t("common:OTHER.FROM")}>
        {" "}
        {from}
      </DatePicker>

      <DatePicker onChange={handleToChange} value={parseDate(to)} clearable placeholder={t("common:OTHER.TO")}>
        {to}{" "}
      </DatePicker>
    </Grid>
  );
};

interface Props extends ComponentProps {
  range?: string;
}

export const RangeComponent = React.memo<Props>(({ range, onChange, ...props }) => {
  return <DateRangeComponent value={range} onChange={onChange} {...props} />;
});
